const einProgram = {
  einProgram: {
    pageHeader: 'Leads and Enphase Installer Network',
    title: 'EIN Membership Accepted',
    overview: 'Overview',
    noCompany: 'No Company Found',
    goToDashboard: 'Go to Dashboard',
    messageFromCeo: 'Read the Message from our CEO',
    companyProfileLink: 'Update your Company Profile',
    serviceAreasLink: 'Select your Service Areas',
    leadsPreferencesLink: 'Set your Leads Preferences',
    reviewInstallerLink: 'Review Installer T&Cs',
    open: 'open',
    video: 'video',
    selected: 'selected',
    learnMore: 'Learn More',
    completed: 'Completed',
    pending: 'Pending',
    optInDisabledHeader: 'EIN Program (Coming soon)',
    optInDisabledDescription:
      'Enphase Installer Network (EIN) is a great way for homeowners to find you! Homeowners rely on EIN to identify installers that deliver the highest standards of customer service and system quality using Enphase products. As an EIN member, you get to enjoy several benefits that will help you sell more, install more and make more.',
    einTier: 'Your Enphase Installer Network(EIN) tier: ',
    none: 'None',
    viewBenefits: 'To view your EIN benefits, click ',
    here: 'here',
    anyQuestions: ' If you have any questions regarding your EIN membership, please contact your',
    enphaseAccountRepresentative: ' Enphase Account representative.',
    learnReceivingLeads: 'Learn how you will be receiving leads from the Enphase digital platform ',
    benefitsOfEIN: 'View the benefits of the EIN ',
    contactEnphaseRepresentative:
      '. Please contact your Enphase Account representative to learn more about EIN and Enphase Leads Program.',
    congratulations: 'Congratulations!',
    whichInstaller: '%{tierName} Installer. ',
    invitationText1: 'You have been invited to participate in the Enphase Installer Network(EIN) as a ',
    invitationText2:
      'The Enphase Installer Network (EIN) is our trusted network of installers who deliver exceptional homeowner experience using Enphase products. The EIN is designed to strengthen our relationship with you and to accelerate your growth. As an EIN member, you get to enjoy several benefits that will help you sell more, install more and make more. Please review the complete benefits ',
    acceptInvitation: 'To accept your invitation:',
    acceptTerms: 'I accept the Terms and Conditions',
    cellmodemCheck: 'I accept the',
    cellmodemTeamcondition: ' Terms and Conditions ',
    cellmodemLinkTitle: 'of the Mobile Connect Data Extension',
    notEstablished: 'Not Established.',
    contactEin: 'Please contact your Enphase Account representative to learn more about EIN​.',
    getFreeLeads: 'To get free leads, please complete the below steps:'
  }
};

export default einProgram;
